import React from "react";
import { useSelector, useDispatch } from "react-redux";
//console.log("src/components/Filter.js");

// get all unique values
const getUnique = (items, value1, value2) => {
  if (value2) {
    return [
      ...new Set(
        items
          .filter((item) => item.size === value2)
          .map((subitem) => subitem[value1])
      ),
    ];
  }
  return [...new Set(items.map((item) => item[value1]))];
};

function checkWidth(width) {
  return (width = Number(roundTo(Math.floor(width / 4.1) * 4.1, 1)));
}

function roundTo(n, digits) {
  let negative = false;
  if (digits === undefined) {
    digits = 0;
  }
  if (n < 0) {
    negative = true;
    n = n * -1;
  }
  let multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  n = (Math.round(n) / multiplicator).toFixed(1);
  if (negative) {
    n = (n * -1).toFixed(2);
  }
  return n;
}

function Filter() {
  const calc = useSelector((state) => state.calc);
  const init = useSelector((state) => state.init);
  const dispatch = useDispatch();
  // WIDTH
  const uc10 = checkWidth(init.c10);
  const uc11 = checkWidth(init.c11);
  const ub = checkWidth(init.b);
  const tv4 = init.tv4;
  let uwidth = calc.width;
  let usize = calc.size;
  let ssize = calc.size;
  let ulapp = calc.lapp;
  let slapp = calc.lapp;
  let ulaph = calc.laph;
  let slaph = calc.laph;

  if (uwidth === null) {
    if (init.b === false || init.b === "") {
      uwidth = 0;
    } else {
      // defaults from url
      uwidth = ub;
    }
    // test for Min-Max
    // if (uwidth < uc10) {
    //   uwidth = uc10;
    // }
    // if (uwidth > uc11) {
    //   uwidth = uc11;
    // }
  }
  const show_width = (
    <div className="form-group">
      <label htmlFor="width">
        {init.tv1}
        {init.tv16}
      </label>
      <input
        name="width"
        id="width"
        type="number"
        className="form-control"
        min={uc10}
        max={uc11}
        step="4.1"
        value={uwidth}
        onChange={(e) =>
          dispatch({
            type: "HANDLE_CHANGE",
            etype: e.target.type,
            echecked: e.target.checked,
            evalue: e.target.value,
            ename: e.target.name,
            ewidth: uwidth,
            esize: usize,
            elapp: ulapp,
            elaph: ulaph,
            tv4: tv4,
            overlap: ulap,
          })
        }
      ></input>
      {init.task2}
    </div>
  );

  // SIZE
  if (usize === null || usize === "") {
    if (init.s === false || init.s === "") {
      ssize = tv4;
      usize = "all";
    } else {
      usize = ssize = init.s;
    }
  } else if (usize === "all") {
    ssize = tv4;
  }
  // get unique sizes
  let usizes = getUnique(calc.types, "size");
  // sort
  usizes.sort((a, b) => {
    return a > b;
  });
  // add 'all'
  usizes = [tv4, ...usizes];
  // map to jsx
  usizes = usizes.map((item, index) => {
    return (
      <option key={index} value={item}>
        {item}
      </option>
    );
  });

  const show_sizes = (
    <div className="form-group">
      <label htmlFor="size">
        {init.tv2}
        {init.tv16}
      </label>
      <select
        name="size"
        id="size"
        className="form-control"
        value={ssize}
        onChange={(e) =>
          dispatch({
            type: "HANDLE_CHANGE",
            etype: e.target.type,
            echecked: e.target.checked,
            evalue: e.target.value,
            ename: e.target.name,
            ewidth: uwidth,
            esize: usize,
            elapp: ulapp,
            elaph: ulaph,
            tv4: tv4,
            overlap: ulap,
          })
        }
      >
        {usizes}
      </select>
    </div>
  );

  // LAPP
  // get unique lapp
  if (ulapp === "all") {
    slapp = tv4;
  }
  let lapps = [];
  if (usize !== "all") {
    lapps = getUnique(calc.types, "lapp", usize);
  } else {
    lapps = getUnique(calc.types, "lapp");
  }
  // sort
  lapps.sort((a, b) => {
    return a > b;
  });
  // get textvalue items
  lapps = lapps.map((item, index) => {
    return eval("init.tv1" + item);
  });
  // add 'all'
  if (lapps.length > 1) {
    lapps = [tv4, ...lapps];
  } else {
    lapps = [...lapps];
  }
  // map to jsx
  lapps = lapps.map((item, index) => {
    return (
      <option key={index} value={item}>
        {item}
      </option>
    );
  });
  const show_lapp = (
    <>
      {/* select lapp */}
      <div className="form-group">
        <label htmlFor="lapp">
          {init.tv9}
          {init.tv16}
        </label>
        <select
          name="lapp"
          id="lapp"
          className="form-control"
          value={slapp}
          onChange={(e) =>
            dispatch({
              type: "HANDLE_CHANGE",
              etype: e.target.type,
              echecked: e.target.checked,
              evalue: e.target.value,
              ename: e.target.name,
              ewidth: uwidth,
              esize: usize,
              elapp: ulapp,
              elaph: ulaph,
              tv4: tv4,
              overlap: ulap,
            })
          }
        >
          {lapps}
        </select>
        {/*init.tv8*/}
      </div>
      {/* end lapp */}
    </>
  );

  // LAPH
  if (ulaph === "all") {
    slaph = tv4;
  }
  // get unique laph
  let laphs = [];
  if (usize !== "all") {
    laphs = getUnique(calc.types, "laph", usize);
  } else {
    laphs = getUnique(calc.types, "laph");
  }
  // sort
  laphs.sort((a, b) => {
    return a > b;
  });
  // add 'all'
  if (laphs.length > 1) {
    laphs = [tv4, ...laphs];
  } else {
    laphs = [...laphs];
  }
  // map to jsx
  laphs = laphs.map((item, index) => {
    return (
      <option key={index} value={item}>
        {item}
      </option>
    );
  });
  const show_laph = (
    <>
      {/* select laph */}
      <div className="form-group">
        <label htmlFor="laph">
          {init.tv9}
          {init.tv16}
        </label>
        <select
          name="laph"
          id="laph"
          className="form-control"
          value={slaph}
          onChange={(e) =>
            dispatch({
              type: "HANDLE_CHANGE",
              etype: e.target.type,
              echecked: e.target.checked,
              evalue: e.target.value,
              ename: e.target.name,
              ewidth: uwidth,
              esize: usize,
              elapp: ulapp,
              elaph: ulaph,
              tv4: tv4,
              overlap: ulap,
            })
          }
        >
          {laphs}
        </select>
        {init.tv3}
      </div>
      {/* end laph */}
    </>
  );

  // Build Overlap
  let show_overlap = "";
  let ulap = "";
  switch (init.c12) {
    case "all":
      switch (init.o) {
        case "p":
          show_overlap = show_lapp;
          ulap = "p";
          break;
        case "h":
          show_overlap = show_laph;
          ulap = "h";
          break;
        default:
          show_overlap = show_laph;
          ulap = "h";
          break;
      }
      break;
    case "p":
      show_overlap = show_lapp;
      ulap = "p";
      break;
    case "h":
      show_overlap = show_laph;
      ulap = "h";
      break;
    default:
      show_overlap = show_laph;
      ulap = "h";
      break;
  }

  return (
    <section className="calc">
      <form className="filter-form">
        <div>{init.task1}</div>
        {/* input width */}
        {show_width}
        {/* end width */}
        {/* select size */}
        {show_sizes}
        {/* end size */}
        {/* select overlap */}
        {show_overlap}
        {/* end overlap */}
        {/* {show_button} */}
      </form>
      <hr />
    </section>
  );
}

export default Filter;
